<h1 matDialogTitle>Confirm Sending SMS</h1>

<mat-dialog-content>
  <!-- <p>
    Email to send: {{data.email.documentType}}
  </p> -->
  <p>
    Enter SMS details below:
  </p>

  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Country</mat-label>
        <mat-select formControlName="countryNumber" (selectionChange)="countrieChanged()">
          <mat-option *ngFor="let country of countries" [value]="country.countryNumber">
            {{country.countryName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="form.value.countryNumber">
        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Mobile Phone Number *</mat-label>
          <input matInput type="text" formControlName="phoneNumber"
            autocomplete="new-password" v>
          <mat-hint align="end">{{hint}}</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Message *</mat-label>
          <textarea #message matInput rows="2" style="text-align: left;" type="text" minlength="1" maxlength="160" formControlName="message" autocomplete="new-password"></textarea>
          <mat-hint align="end">{{message.value.length}} / 160</mat-hint>
        </mat-form-field>
      </ng-container>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="send()">Send</button>

</mat-dialog-actions>
